import { Post } from "./post.model";
import { Promotion } from "./promotion.model";

export interface IPostPromotion {
  id?: number;
  promotion?: Promotion;
  post?: Post;
  startDate?: Date;
  endDate?: Date;
  codePromo?: string;
  shopName?: string;
  reference?: any;
}

export class PostPromotion implements IPostPromotion {
  constructor(
    public id?: number,
    public promotion?: Promotion,
    public post?: Post,
    public startDate?: Date,
    public endDate?: Date,
    public codePromo?: string,
    public shopName?: string,
    public reference?: any,
  ) {
    this.id = id;
    this.promotion = promotion;
    this.post = post;
    this.startDate = startDate;
    this.endDate = endDate;
    this.codePromo = codePromo;
    this.shopName = shopName;
    this.reference = reference
  }
}
